import { ReactNode } from 'react'

interface FormFieldProps {
  label: string
  description?: string
  children: ReactNode
  className?: string
}

export const FormField = ({ label, description, children, className = '' }: FormFieldProps) => {
  return (
    <div className={className}>
      <label className="mb-2 block text-sm font-medium">{label}</label>
      {children}
      {description && <p className="text-muted-foreground mt-1 text-xs">{description}</p>}
    </div>
  )
}
